import { batteryConcertApplicationBundle } from "./battery-concert-bundle"
import { ConcertApplicationStatus } from "../../../ProposalSetup/financing/concert/ConcertApplicationStatus"

/**
 * Concert Battery application status for the Battery drawers: the shared
 * status over Battery's commands, with the supplemental package beside
 * Concert's loan documents.
 */
export function ConcertBatteryApplicationStatus({
  proposalId,
  onRetry,
}: {
  proposalId: string
  /** Opens the application form again for a confirmed provider rejection. */
  onRetry?: () => void
}): JSX.Element {
  return (
    <ConcertApplicationStatus
      bundle={batteryConcertApplicationBundle}
      proposalId={proposalId}
      onRetry={onRetry}
    />
  )
}
